import './index.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('digital-services');
    if (rootElement) {
        const root = createRoot(rootElement);
        root.render(
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <App />
            </BrowserRouter>
        );
    }
});
